import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Divider,
} from '@mui/material';
import {
  AlertTriangle as WarningIcon
} from 'lucide-react';

const CACHE_KEY = 'kanban_close_mode';

const readCached = () => {
  try { return localStorage.getItem(CACHE_KEY) || 'default'; }
  catch { return 'default'; }
};

const writeCached = (val) => {
  try { localStorage.setItem(CACHE_KEY, val); } catch {}
};

const ConfirmationDialog = ({ open, onClose, onConfirm, fromStatus, toStatus, targetStatusTypeId }) => {
  const isClosingStatus = targetStatusTypeId === 5;

  const [closeMode, setCloseMode] = useState(readCached);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'novo':         return '#3b82f6';
      case 'em andamento': return '#f59e0b';
      case 'finalizado':   return '#10b981';
      default:             return '#6b7280';
    }
  };

  const handleConfirm = () => {
    if (isClosingStatus) writeCached(closeMode);
    onConfirm(true, closeMode);
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          width: '100%',
          maxWidth: '420px',
        },
      }}
    >
      <DialogTitle sx={{ pt: 3, pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <WarningIcon size={24} color="#f59e0b" />
          <Typography variant="h6">
            Confirmar alteração de status
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ px: 3, pt: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Você está prestes a alterar o status do ticket:
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Box
            sx={{
              px: 2, py: 1, borderRadius: 2,
              color: getStatusColor(fromStatus),
              bgcolor: `${getStatusColor(fromStatus)}15`,
              fontSize: '0.9rem',
            }}
          >
            {fromStatus}
          </Box>
          <Box sx={{ mx: 2, fontSize: '1.2rem', color: 'text.secondary' }}>
            →
          </Box>
          <Box
            sx={{
              px: 2, py: 1, borderRadius: 2,
              color: getStatusColor(toStatus),
              bgcolor: `${getStatusColor(toStatus)}15`,
              fontSize: '0.9rem',
            }}
          >
            {toStatus}
          </Box>
        </Box>

        <Typography variant="body2" color="text.secondary">
          Esta ação atualizará o fluxo de trabalho do ticket. Deseja continuar?
        </Typography>

        {isClosingStatus && (
          <>
            <Divider sx={{ my: 2 }} />
            <FormControl component="fieldset" fullWidth>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Como deseja encerrar o chamado?
              </Typography>
              <RadioGroup
                value={closeMode}
                onChange={(e) => setCloseMode(e.target.value)}
              >
                <FormControlLabel
                  value="default"
                  control={<Radio size="small" />}
                  label={
                    <Typography variant="body2">Exibir encerramento padrão</Typography>
                  }
                />
                <FormControlLabel
                  value="quick"
                  control={<Radio size="small" />}
                  label={
                    <Typography variant="body2">Tratamento rápido de chamado</Typography>
                  }
                />
              </RadioGroup>
            </FormControl>
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="outlined"
          onClick={() => onClose(false)}
          sx={{ borderRadius: 2, textTransform: 'none', px: 3 }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          sx={{ borderRadius: 2, textTransform: 'none', px: 3, boxShadow: 'none' }}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
